import React from "react"
import { Icon, IconSize } from "@walmart-web/livingdesign-icons"
import { renderOptionsProps, renderToggleProps } from "./interfaces"
import { concatClassNames } from "helpers/jsxHelpers"

export const ESCAPE_KEY = "Escape"
export const MOUSEDOWN = "mousedown"
export const KEYUP = "keyup"

export const focusInputOnClickSpan = (
	ref: React.RefObject<HTMLInputElement>
) => {
	ref?.current && ref.current.focus()
}

export const renderToggleIcon = (isOpen: boolean, size: IconSize) =>
	isOpen ? (
		<Icon name="ChevronUp" size={size} />
	) : (
		<Icon name="ChevronDown" size={size} />
	)

export const renderDefaultOption = (props: renderOptionsProps) => {
	const { option, optionSelected } = props
	const isActive = option.code === optionSelected?.code

	return (
		<div className={concatClassNames(["dropdown-item", isActive && "active"])}>
			{option?.name}
		</div>
	)
}

export const renderInputDefault = (props: renderToggleProps) => {
	const { optionSelected, placeholder } = props
	const { name } = optionSelected || {}
	const displayValue = name ?? placeholder

	return (
		<div className="dropdown-input dropdown-container">
			<div>{displayValue}</div>
		</div>
	)
}
